import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/legalData";

export default function TermsOfService() {
  return (
    <LegalLayout title="Termini e Condizioni d'uso" slug="/termini">
      <p className="lead">
        I presenti Termini e Condizioni (di seguito "<b>Termini</b>") disciplinano l'utilizzo della Piattaforma <b>{COMPANY.brand}</b> (<a href={COMPANY.app_url}>{COMPANY.app_url}</a>), erogata da <b>{COMPANY.legal_name}</b> con sede in {COMPANY.legal_address.full}, P.IVA {COMPANY.vat_number} (di seguito "<b>{COMPANY.brand}</b>" o "<b>Titolare</b>").
      </p>

      <h2>1. Definizioni</h2>
      <ul>
        <li><b>Piattaforma</b>: il servizio web e applicazione web installabile (PWA) {COMPANY.brand}, accessibile su <a href={COMPANY.app_url}>{COMPANY.app_url}</a>.</li>
        <li><b>Cliente</b>: persona fisica automobilista che utilizza la Piattaforma per segnalare un sinistro al proprio Consulente.</li>
        <li><b>Consulente</b>: studio professionale o singolo professionista (consulente infortunistico, patrocinatore stragiudiziale, avvocato) che si registra alla Piattaforma per gestire le pratiche dei propri clienti.</li>
        <li><b>Pratica</b>: la segnalazione di sinistro con relativi dati, foto, video, audio e firma elettronica.</li>
      </ul>

      <h2>2. Oggetto del servizio</h2>
      <p>
        {COMPANY.brand} è una piattaforma SaaS multi-tenant che consente al Cliente di trasmettere al proprio Consulente, in modo rapido e strutturato, le informazioni relative a un sinistro stradale (dati anagrafici, fotografie, video, audio, posizione GPS, descrizione testuale) e di firmare elettronicamente la relativa pratica ai sensi del Reg. UE 910/2014 ("eIDAS") con il livello di Firma Elettronica Semplice (FES).
      </p>
      <p>
        {COMPANY.brand} <b>non fornisce</b> alcun servizio di consulenza legale, infortunistica, assicurativa o di intermediazione assicurativa. {COMPANY.brand} è un mero strumento tecnologico di trasmissione e archiviazione dati tra Cliente e Consulente. Il rapporto contrattuale relativo alla gestione del sinistro intercorre esclusivamente tra il Cliente e il Consulente.
      </p>

      <h2>3. Registrazione e account</h2>
      <h3>3.1 Cliente</h3>
      <p>
        Il Cliente fornisce i propri dati anagrafici al primo accesso. La registrazione è gratuita e non prevede contratti di abbonamento. Il Cliente è responsabile della veridicità e correttezza dei dati forniti.
      </p>
      <h3>3.2 Consulente</h3>
      <p>
        Il Consulente si registra fornendo nome studio, email, telefono, password. Il Consulente è tenuto a fornire dati veritieri e a custodire le credenziali in modo riservato; ogni attività compiuta tramite tali credenziali si presume effettuata dal Consulente.
      </p>

      <h2>4. Firma elettronica delle pratiche</h2>
      <p>
        La Piattaforma implementa una procedura di firma elettronica semplice (FES) basata su:
      </p>
      <ol>
        <li>Codice OTP a 6 cifre, inviato via email all'indirizzo del Cliente al momento dell'invio della pratica, da inserire in apposita maschera (scadenza 10 minuti, max 5 tentativi).</li>
        <li>Conferma successiva tramite link inviato per email al Cliente.</li>
      </ol>
      <p>
        Tali evidence sono conservate insieme alla pratica e fanno piena prova ai fini civilistici quale firma elettronica semplice ai sensi dell'art. 25.1 del Reg. UE 910/2014 e dell'art. 20 del D.Lgs. 82/2005 (Codice dell'Amministrazione Digitale). Per atti che richiedono Firma Elettronica Avanzata o Qualificata si rinvia al rapporto contrattuale Cliente-Consulente extra-Piattaforma.
      </p>

      <h2>5. Obblighi dell'utente</h2>
      <p>L'utente si obbliga a:</p>
      <ul>
        <li>Utilizzare la Piattaforma in conformità a leggi e regolamenti vigenti</li>
        <li>Non caricare contenuti illeciti, offensivi, lesivi di diritti di terzi, o non pertinenti alla finalità del servizio</li>
        <li>Non tentare di accedere ad aree riservate non autorizzate</li>
        <li>Non interferire con la sicurezza o l'integrità della Piattaforma (es. tentativi di intrusione, denial-of-service, ingegneria inversa)</li>
        <li>Non utilizzare la Piattaforma per finalità diverse dalla segnalazione e gestione di sinistri</li>
      </ul>

      <h2>6. Limiti tecnici e tariffari</h2>
      <p>
        Per pratica sono consentiti: fino a <b>15 fotografie</b> (max 25MB cad), <b>2 video</b> (max 100MB cad), <b>3 file audio</b> (max 25MB cad). Tali limiti possono essere modificati a discrezione del Titolare. Il servizio per il Cliente è gratuito; il servizio per il Consulente può essere erogato secondo piani tariffari pubblicati sul sito.
      </p>

      <h2>7. Conservazione dei dati</h2>
      <p>
        I dati relativi alla pratica sono conservati per il tempo necessario all'erogazione del servizio e, in ogni caso, per un periodo aggiuntivo (30, 60 o 90 giorni) successivo alla chiusura della pratica, configurabile dal Consulente. Alla chiusura della pratica, il Consulente può scaricare un archivio ZIP contenente PDF di riepilogo + tutti i file media originali, ai fini della conservazione documentale presso il proprio studio. Per i dettagli si rinvia alla <a href="/privacy">Privacy Policy</a>.
      </p>

      <h2>8. Proprietà intellettuale</h2>
      <p>
        Marchio, logo, codice sorgente, interfaccia grafica e contenuti della Piattaforma sono di proprietà esclusiva del Titolare o dei suoi licenzianti. È vietata qualsiasi riproduzione, modifica o utilizzo non autorizzato.
      </p>
      <p>
        L'utente mantiene la proprietà dei contenuti caricati (foto, video, audio, descrizioni) e concede al Titolare una licenza limitata, gratuita e revocabile, per il tempo strettamente necessario all'erogazione del servizio, ai fini della trasmissione e archiviazione di tali contenuti.
      </p>

      <h2>9. Esclusione e limitazione di responsabilità</h2>
      <p>
        Il Titolare si impegna a garantire la disponibilità e il corretto funzionamento della Piattaforma, ma non garantisce un livello di servizio assoluto. Il Titolare <b>non risponde</b> di:
      </p>
      <ul>
        <li>Eventuali ritardi o impossibilità nell'invio email dovuti a fornitori terzi (es. Resend, ESP destinatari)</li>
        <li>Mancato funzionamento dovuto a cause di forza maggiore, malfunzionamenti di rete, fornitori terzi, attacchi informatici</li>
        <li>Errori, omissioni o false dichiarazioni dell'utente nei dati caricati</li>
        <li>Conseguenze derivanti dall'attività professionale del Consulente nei confronti del Cliente, che resta extra-piattaforma</li>
      </ul>

      <h2>10. Recesso e cessazione</h2>
      <p>
        L'utente può cessare l'utilizzo della Piattaforma in qualunque momento ed esercitare i diritti previsti dalla normativa privacy (cfr. <a href="/privacy">Privacy Policy</a>). Il Titolare si riserva di sospendere o terminare l'account in caso di violazione dei presenti Termini, con preavviso ove possibile.
      </p>

      <h2>11. Modifiche</h2>
      <p>
        Il Titolare può aggiornare i presenti Termini per adeguarli a novità normative o operative. Le modifiche saranno pubblicate su questa pagina e, ove sostanziali, comunicate via email agli utenti registrati.
      </p>

      <h2>12. Legge applicabile e foro competente</h2>
      <p>
        I presenti Termini sono regolati dalla legge italiana. Per ogni controversia è competente in via esclusiva il <b>Foro di Nola</b>, salva l'applicazione di norme inderogabili a favore del consumatore (art. 66-bis Codice del Consumo), nel qual caso sarà competente il foro di residenza o domicilio del consumatore.
      </p>

      <h2>13. Contatti</h2>
      <p>Per qualsiasi richiesta relativa ai presenti Termini:</p>
      <ul>
        <li><b>Supporto clienti</b>: <a href={`mailto:${COMPANY.support_email}`}>{COMPANY.support_email}</a></li>
        <li><b>Contatti istituzionali</b>: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
        <li><b>PEC</b>: <a href={`mailto:${COMPANY.pec}`}>{COMPANY.pec}</a></li>
        <li><b>Telefono</b>: <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}>{COMPANY.phone}</a></li>
        <li><b>Sede</b>: {COMPANY.legal_address.full}</li>
      </ul>
    </LegalLayout>
  );
}
